var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 12C15.3333 12.5 15.1933 12.9734 14.9467 13.3734C14.8067 13.6134 14.6267 13.8267 14.42 14C13.9533 14.42 13.34 14.6667 12.6667 14.6667C11.8533 14.6667 11.1267 14.3001 10.6467 13.7267C10.6333 13.7067 10.6133 13.6934 10.6 13.6734C10.52 13.58 10.4467 13.48 10.3867 13.3734C10.14 12.9734 10 12.5 10 12C10 11.16 10.3867 10.4067 11 9.92004C11.46 9.55338 12.04 9.33337 12.6667 9.33337C13.3333 9.33337 13.9333 9.57335 14.4 9.98002C14.48 10.04 14.5533 10.1134 14.62 10.1867C15.06 10.6667 15.3333 11.3 15.3333 12Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6605 11.9866H11.6738",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 11.0133V13.0066",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 4.96008L7.99995 8.36674L13.8466 4.98006",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4068L8 8.36011",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4071 6.11338L14.4071 9.88673C14.4071 9.92007 14.4071 9.9467 14.4004 9.98003C13.9338 9.57337 13.3337 9.33339 12.6671 9.33339C12.0404 9.33339 11.4604 9.55339 11.0004 9.92006C10.3871 10.4067 10.0004 11.1601 10.0004 12.0001C10.0004 12.5001 10.1404 12.9734 10.3871 13.3734C10.4471 13.4801 10.5204 13.5801 10.6004 13.6734L9.38042 14.3467C8.62042 14.7734 7.38041 14.7734 6.62041 14.3467L3.06041 12.3734C2.25375 11.9267 1.59375 10.8067 1.59375 9.88673L1.59375 6.11338C1.59375 5.19338 2.25375 4.07339 3.06041 3.62672L6.62041 1.65337C7.38041 1.22671 8.62042 1.22671 9.38042 1.65337L12.9404 3.62672C13.7471 4.07339 14.4071 5.19338 14.4071 6.11338Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrder);
export default __webpack_public_path__ + "static/media/add_order.b7ba44a64aeded32b8e9e692e2fb8653.svg";
export { ForwardRef as ReactComponent };